import React from 'react';
import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { CampaignBanner } from '../../../../SectionBlocks/blocks/Campaign';
import { CampaignBlockType } from '../../../../../../../types/campaignBlockType';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';

interface CampaignBlockSerializerProps {
  value: CampaignBlockType;
}

export const CampaignBlock = ({ value }: CampaignBlockSerializerProps) => (
  <CampaignBanner campaign={{ ...value, variant: value.variant || 'medium' }} />
);

export const CampaignBlockSerializer =
  () =>
  ({ value }: CampaignBlockSerializerProps) => (
    <StyledArticleBlockContentGridCol className="campaignBlock">
      <CampaignBlock value={value} />
    </StyledArticleBlockContentGridCol>
  );

const StyledArticleBlockContentGridCol = styled(ArticleBlockContentGridCol)`
  display: flow-root;
  margin: ${spacing.space32} 0;

  @media (max-width: ${breakpoints.m}) {
    margin: ${spacing.space24} 0;
  }
`;
